import React from 'react';
import { useSceneLogo } from '@/lib/hooks/useSceneLogo';
import styles from './index.module.less';

/**
 * 独立的校徽组件
 * 始终显示在页面顶部，保持固定位置和大小
 */
function SchoolLogo() {
  const { logoSrc, shouldShowLogo } = useSceneLogo();

  if (!shouldShowLogo || !logoSrc) {
    return null;
  }

  return (
    <div className={styles.logoContainer}>
      <img src={logoSrc} alt="校徽" className={styles.logo} />
    </div>
  );
}

export default SchoolLogo;
